import React, { Component } from 'react';
import PropTypes from 'prop-types';
import raf from 'raf';
import ease from 'ease-component';

raf.polyfill();

class Counter extends Component {
  constructor() {
    super();
    this.state = {
      value: 0,
    };
    this.animate = this.animate.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.start = Date.now();
    this.stop = false;
    raf(this.animate);
  }

  componentWillReceiveProps() {
    this.start = Date.now();
    this.stop = false;
    raf(this.animate);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  animate() {
    if (this.stop) return;
    raf(this.animate);
    this.draw();
  }

  draw() {
    if (!this.mounted) {
      return;
    }

    const begin = this.state.value;
    const end = this.props.value;
    if (Math.floor(Math.abs(end - begin)) === 0) {
      this.setState({ value: end });
      this.stop = true;
      return;
    }
    const duration = this.props.duration || 1000;
    const now = Date.now();
    let { easing } = this.props;
    easing = easing && easing in ease ? easing : 'outSine';

    let percentage = (now - this.start) / duration;
    percentage = percentage > 1 ? 1 : percentage;
    const easeVal = ease[easing](percentage);
    const value = begin + ((end - begin) * easeVal);
    this.setState({ value });
  }

  render() {
    const { value } = this.state;
    // let destValue = this.props.value;
    const childrenWithProps = React.Children.map(
      this.props.children,
      child => React.cloneElement(child, { value }),
    );
    const style = { opacity: 1 };
    return (
      <span className="counter" style={style}>
        {childrenWithProps}
      </span>
    );
  }
}

Counter.propTypes = {
  value: PropTypes.number,
  duration: PropTypes.number,
  easing: PropTypes.string,
  children: PropTypes.node,
};
Counter.defaultProps = {
  value: 0,
  duration: 2000,
  easing: 'outSine',
  children: null,
};

export default Counter;
